/**
 * "Bundle is in beta." above the shell (design: https://claude.ai/artifact/HPcQhFwDizthDPZvNavoVt, Beta.dc.html):
 * What's new opens the blog, Send feedback the feedback sheet, × hides it. When it shows is Beta.showBetaBanner
 * (packages/core); it shares the top slot with the connection banner and "Get the app" (platform/topBanner.ts).
 */
import { Support } from "@bundle/core";
import { Banner, openLink, usePreferences, useT } from "@bundle/ui";
import { dismissBeta, useBetaBannerWanted } from "../platform/beta.ts";
import { useTopBanner } from "../platform/topBanner.ts";

export function BetaBanner({ onFeedback }: { onFeedback: () => void }) {
  const t = useT();
  const prefs = usePreferences();
  const shown = useTopBanner("beta", useBetaBannerWanted());
  if (!shown) return null;
  return (
    <Banner
      tone="info"
      icon="megaphone"
      placement="edge"
      title={t("beta.banner.title")}
      inlineTitle
      message={t("beta.banner.message")}
      secondaryAction={{ label: t("beta.banner.whatsNew"), onPress: () => openLink(Support.whatsNewUrl(prefs.locale)), testID: "beta-banner-whats-new" }}
      action={{ label: t("beta.banner.feedback"), variant: "primary", onPress: onFeedback, testID: "beta-banner-feedback" }}
      onDismiss={() => dismissBeta()}
      dismissLabel={t("beta.banner.dismiss")}
      testID="beta-banner"
    />
  );
}
